const DarkTheme = {
  "--b1": "#141414",
  "--b2": "#1a1a1a",
  "--b3": "#2b2b2b",
  "--b4": "#3d3d3d",
  "--f1": "#FFFFFF",
  "--s1": "#000000",
  "--s2": "#FFFFFF",
  "--s3": "#33C9FF",
  "--s4": "#1DB954",
  "--s5": "#1ED75F",
  "--s6": "#5EAE59",
  "--s7": "#0A1136"
};

export default DarkTheme;
